import { Card, CardActionArea, CardMedia, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useAppDispatch } from "../../app/store/configureStore";
import { setProductParams } from "../catalog/catalogSlice";
import { imageUrls } from "../../app/models/categories";
interface Props {
  category: string
}

export default function CategoryCard({category} : Props) {
  const dispatch = useAppDispatch()

  function handleOnClick() {
      dispatch((setProductParams({categories: [category]})))
  }
  

  return (
    
      <Card sx={{
        maxWidth: 370,
        margin: "0 auto",
        padding: "0.1em",
      }}>
          <CardActionArea component={Link} to={`/catalog`} onClick={handleOnClick}>
              
              <CardMedia
                sx={{ height: 350, backgroundSize: 'contain', bgcolor: 'white', padding: "1em 1em 0 1em", objectFit: "contain" }}
                // image={`/images/categories/${category}.jpeg`}
                image={imageUrls.find((imageUrl) => imageUrl.category === category)?.url}
                title={category}
              />
            
              <CardContent>
                  <Typography variant="h6" gutterBottom align="center"
                  >
                      {category}
                  </Typography>
              </CardContent>
          </CardActionArea>
      </Card>
     
  )
}